import {
  FETCH_PERSON_SUCCESS,
  FETCH_PERSONS_MIN_SUCCESS,
  FETCH_PERSONS_STATS_SUCCESS,
  CLEAR_PERSONS,
  UPDATE_PERSON,
  UPLOAD_PERSON_PICTURE,
  ADD_PERSON,
  CLEAR_PERSON,
  CREATE_PERSON_START,
  UPDATE_PERSON_START_END,
  DELETE_PERSON_START,
  DELETE_PERSON_END,
  ADD_PERSON_ASSET,
  UPDATE_PERSON_ASSET,
  PERSONS_FAILURE,
  SET_PERSON_ID,
  SET_LOGGED_USER_ID,
  ADD_PERSON_ENTITLEMENT,
  UPDATE_PERSON_ENTITLEMENT,
  DELETE_PERSON_ENTITLEMENT,
  ADD_SALARY,
  UPDATE_SALARY,
  DELETE_SALARY,
  ADD_COVSTATE,
  UPDATE_COVSTATE,
  ADD_PERSON_TIMEPLAN,
  UPDATE_PERSON_TIMEPLAN,
  DELETE_PERSON_TIMEPLAN,
  SET_RECURRING_ABSENCE_ID,
  UPDATE_RECURRING_ABSENCE,
} from "actions/types";
import { DateTime } from "luxon";
import { produce } from "immer";

const initialState = {
  Person: {},
  PersonsMin: [],
  PersonsStats: [],
  error: "",
  personId: -1,
  absenceId: -1,
  loggedUserId: 0,
};

const personsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const PL = action.payload;
    let key;
    let personKey;
    let person;
    // eslint-disable-next-line
    switch (action.type) {
      case FETCH_PERSON_SUCCESS:
        draft.Person = PL;
        draft.error = "";
        break;
      case FETCH_PERSONS_MIN_SUCCESS:
        draft.PersonsMin = PL;
        draft.error = "";
        break;
      case FETCH_PERSONS_STATS_SUCCESS:
        draft.PersonsStats = PL;
        draft.error = "";
        break;
      case CLEAR_PERSONS:
        draft.PersonsMin = [];
        break;
      case PERSONS_FAILURE:
        draft.error = PL;
        break;
      case UPDATE_PERSON:
        personKey = draft.PersonsMin.findIndex(
          (P) => parseInt(P.id) === parseInt(PL.id),
        );
        draft.PersonsMin[personKey] = PL;
        draft.PersonsMin[personKey].listName =
          PL.lastName + ", " + PL.firstName;
        draft.PersonsMin[personKey].longName = (
          PL.personNumber +
          " " +
          PL.lastName +
          ", " +
          PL.firstName
        ).trim();
        break;
      case UPLOAD_PERSON_PICTURE:
        draft.Person.picture = PL.fileName;
        break;
      case ADD_PERSON:
        draft.PersonsMin = [
          ...draft.PersonsMin,
          {
            ...PL,
            id: PL.id.toString(),
            listName: PL.lastName + ", " + PL.firstName,
            longName: (
              PL.personNumber +
              " " +
              PL.lastName +
              ", " +
              PL.firstName
            ).trim(),
          },
        ];
        break;
      case CLEAR_PERSON:
        draft.Person = {};
        break;
      case CREATE_PERSON_START:
        personKey = draft.PersonsMin.findIndex(
          (P) => parseInt(P.id) === PL.userId,
        );
        person = draft.PersonsMin[personKey];
        person.startEndDates.push(PL);
        draft.Person.startEndDates.push(PL);
        break;
      case UPDATE_PERSON_START_END:
        personKey = draft.PersonsMin.findIndex(
          (P) => parseInt(P.id) === PL.userId,
        );
        person = draft.PersonsMin[personKey];
        key = person.startEndDates.findIndex((SE) => SE.id === PL.id);
        person.startEndDates[key] = PL;
        key = draft.Person.startEndDates.findIndex((SE) => SE.id === PL.id);
        draft.Person.startEndDates[key] = PL;
        break;
      case DELETE_PERSON_START:
        personKey = draft.PersonsMin.findIndex(
          (P) => parseInt(P.id) === PL.userId,
        );
        person = draft.PersonsMin[personKey];
        key = person.startEndDates.findIndex((SE) => parseInt(SE.id) === parseInt(PL.id));
        person = {
          ...person,
          startEndDates: person.startEndDates.splice(key, 1),
        };
        draft.Person = draft.PersonsMin[personKey];
        break;
      case DELETE_PERSON_END:
        personKey = draft.PersonsMin.findIndex(
          (P) => parseInt(P.id) === PL.userId,
        );
        person = draft.PersonsMin[personKey];
        key = person.startEndDates.findIndex((SE) => parseInt(SE.id) === parseInt(PL.id));
        person.startEndDates[key].endDate = "";
        person.startEndDates[key].endReason = "";
        draft.Person = draft.PersonsMin[personKey];
        break;
      case SET_PERSON_ID:
        draft.personId = PL;
        break;
      case SET_LOGGED_USER_ID:
        draft.loggedUserId = action.payload;
        break;
      case ADD_PERSON_ENTITLEMENT:
        draft.Person.entitlements = [...draft.Person.entitlements, PL];
        break;
      case UPDATE_PERSON_ENTITLEMENT:
        key = draft.Person.entitlements.findIndex((E) => E.id === PL.id);
        draft.Person.entitlements[key] = PL;
        break;
      case DELETE_PERSON_ENTITLEMENT:
        key = draft.Person.entitlements.findIndex((E) => E.id === PL.id);
        draft.Person.entitlements.splice(key, 1);
        break;
      case ADD_SALARY:
        draft.Person.wages = [...draft.Person.wages, PL];
        break;
      case UPDATE_SALARY:
        key = draft.Person.wages.findIndex((E) => E.id === PL.id);
        draft.Person.wages[key] = PL;
        break;
      case DELETE_SALARY:
        key = draft.Person.wages.findIndex((E) => E.id === PL.id);
        draft.Person.wages.splice(key, 1);
        break;
      case ADD_COVSTATE:
        draft.Person.covstates = [...draft.Person.covstates, PL];
        break;
      case UPDATE_COVSTATE:
        key = draft.Person.covstates.findIndex((E) => E.id === PL.id);
        draft.Person.covstates[key] = PL;
        break;
      case ADD_PERSON_TIMEPLAN:
        draft.Person.weeklyTimePlans = [...draft.Person.weeklyTimePlans, PL];
        draft.Person.weeklyTimePlans.sort(function (a, b) {
          return (
            DateTime.fromSQL(b.validSince) - DateTime.fromSQL(a.validSince)
          );
        });
        break;
      case UPDATE_PERSON_TIMEPLAN:
        key = draft.Person.weeklyTimePlans.findIndex((WTP) => WTP.id === PL.id);
        draft.Person.weeklyTimePlans[key] = PL;
        draft.Person.weeklyTimePlans.sort(function (a, b) {
          return (
            DateTime.fromSQL(b.validSince) - DateTime.fromSQL(a.validSince)
          );
        });
        break;
      case DELETE_PERSON_TIMEPLAN:
        key = draft.Person.weeklyTimePlans.findIndex((WTP) => WTP.id === PL.id);
        draft.Person.weeklyTimePlans.splice(key, 1);
        break;
      case SET_RECURRING_ABSENCE_ID:
        draft.absenceId = action.payload;
        break;
      case UPDATE_RECURRING_ABSENCE:
        key = draft.Person.recurringAbsences.findIndex(
          (RA) => parseInt(RA.id) === parseInt(PL.id),
        );
        draft.Person.recurringAbsences[key] = PL;
        break;
      default:
        return state;
    }
  });

export default personsReducer;
